import { ethers } from 'ethers';
import { NETWORK_CONFIG } from '../config/constants';

let provider = null;
let isConnecting = false; // Flag to prevent reload during connection

export const getProvider = () => {
  if (!window.ethereum) {
    throw new Error('No wallet detected');
  }
  if (!provider) {
    provider = new ethers.providers.Web3Provider(window.ethereum);
  }
  return provider;
};

// Export flag checker for App.js
export const getIsConnecting = () => isConnecting;

export const connectWallet = async () => {
  try {
    isConnecting = true; // Set flag when connection starts
    
    if (!window.ethereum) {
      throw new Error('Please install MetaMask or another Web3 wallet');
    }

    const accounts = await window.ethereum.request({ 
      method: 'eth_requestAccounts' 
    });

    if (!accounts || accounts.length === 0) {
      throw new Error('No accounts found');
    }

    provider = new ethers.providers.Web3Provider(window.ethereum);
    
    // Check current network
    const network = await provider.getNetwork();
    const currentChainId = '0x' + network.chainId.toString(16);
    const expectedChainId = NETWORK_CONFIG.chainId.toLowerCase();
    
    console.log('Current network:', currentChainId, 'Expected:', expectedChainId);
    
    if (currentChainId.toLowerCase() !== expectedChainId) {
      console.log('Switching network...');
      try {
        await switchNetwork();
      } catch (error) {
        console.warn('Network switch failed, continuing with connection:', error);
        // Don't throw error for Trust Wallet compatibility
      }
    }

    // Small delay before clearing flag to ensure Trust Wallet stabilizes
    setTimeout(() => {
      isConnecting = false;
    }, 500);
    
    return accounts[0];
  } catch (error) {
    isConnecting = false; // Clear flag on error
    console.error('Error connecting wallet:', error);
    throw error;
  }
};

export const getCurrentNetwork = async () => {
  try {
    if (!window.ethereum) return null;
    const chainId = await window.ethereum.request({ method: 'eth_chainId' });
    return chainId;
  } catch (error) {
    console.error('Error getting network:', error);
    return null;
  }
};

export const switchNetwork = async () => {
  try {
    await window.ethereum.request({
      method: 'wallet_switchEthereumChain',
      params: [{ chainId: NETWORK_CONFIG.chainId }],
    });
  } catch (error) {
    if (error.code === 4902) {
      await window.ethereum.request({
        method: 'wallet_addEthereumChain',
        params: [NETWORK_CONFIG],
      });
    } else {
      throw error;
    }
  }
};

export const getCurrentAccount = async () => {
  try {
    if (!window.ethereum) return null;
    
    // Simple, direct check - Trust Wallet compatible
    const accounts = await window.ethereum.request({ method: 'eth_accounts' });
    return accounts && accounts.length > 0 ? accounts[0] : null;
  } catch (error) {
    console.error('Error getting account:', error);
    return null;
  }
};

export const formatAddress = (address) => {
  if (!address) return '';
  return `${address.substring(0, 6)}...${address.substring(address.length - 4)}`;
};

export const fromWei = (amount) => {
  try {
    return ethers.utils.formatEther(amount);
  } catch (error) {
    return '0';
  }
};

export const toWei = (amount) => {
  try {
    return ethers.utils.parseEther(amount.toString());
  } catch (error) {
    return ethers.BigNumber.from(0);
  }
};

export const onAccountsChanged = (callback) => {
  if (window.ethereum && window.ethereum.on) {
    window.ethereum.on('accountsChanged', (accounts) => {
      callback(accounts && accounts.length > 0 ? accounts[0] : null);
    });
  }
};

export const onChainChanged = (callback) => {
  if (window.ethereum && window.ethereum.on) {
    window.ethereum.on('chainChanged', (chainId) => {
      callback(chainId);
    });
  }
};